import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { mdiPlus } from '@mdi/js';

import { ActionButton } from 'common/components/ActionButton';
import { Icon } from 'common/components/Icon';
import { PageTitle } from 'common/components/PageTitle';
import { LocationManageDrawer } from 'organisation/components/LocationManageDrawer';
import { LocationsManagementTable } from 'organisation/components/LocationsManagementTable';
import { useRouteMatch } from 'route/hooks/useRouteMatch';
import { getUrl } from 'route/utils/getUrl';

import { BasePage } from './BasePage';

export const LocationsManagementPage = () => {
    const [translate] = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const { id: locationId } = useParams();

    const createDrawerOpen = !!useRouteMatch(
        'MANAGEMENT_SETTINGS_LOCATION_CREATE'
    );
    const editDrawerOpen = !!useRouteMatch('MANAGEMENT_SETTINGS_LOCATION_EDIT');
    const manageDrawerOpen = createDrawerOpen || editDrawerOpen;

    const handleCloseDrawer = () => {
        const searchParams = new URLSearchParams(location.search);
        const url = `${getUrl('MANAGEMENT_SETTINGS_LOCATIONS')}?${searchParams}`;

        navigate(url);
    };

    return (
        <BasePage contentContainerMaxWidth="lg">
            <PageTitle>
                {translate('locationsManagementPage.browserTitle')}
            </PageTitle>

            <Box sx={{ pt: 4 }}>
                <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                    <Grid size="grow">
                        <Typography variant="h1">
                            {translate('locationsManagementPage.pageTitle')}
                        </Typography>
                    </Grid>

                    <Grid size="auto">
                        <ActionButton
                            outlined
                            variant="extended"
                            onClick={() => {
                                navigate(
                                    getUrl(
                                        'MANAGEMENT_SETTINGS_LOCATION_CREATE'
                                    )
                                );
                            }}
                        >
                            <Box>
                                <Icon path={mdiPlus} size="2.4rem" />
                            </Box>

                            {translate('locationsManagementPage.newLocation')}
                        </ActionButton>
                    </Grid>
                </Grid>
            </Box>

            <Box sx={{ py: 4 }}>
                <LocationsManagementTable />
            </Box>

            <LocationManageDrawer
                locationId={editDrawerOpen ? locationId : undefined}
                open={manageDrawerOpen}
                onClose={handleCloseDrawer}
            />
        </BasePage>
    );
};
